module.exports = __webpack_public_path__ + "img/user.e91d7d87.svg";